module.exports = __webpack_public_path__ + "img/A类设备故障排名@3x.0330a4b8.png";